import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Services } from "./pages/Services";
import { Products } from "./pages/Products";
import { PMOC } from "./pages/PMOC";
import { Contact } from "./pages/Contact";
import { ClientArea } from "./pages/ClientArea";
import { AdminLogin } from "./pages/AdminLogin";
import { Dashboard } from "./pages/Dashboard";
import { Portal } from "./pages/Portal";
import { Documents } from "./pages/Portal/Documents";
import { Propostas } from "./pages/Portal/Propostas";
import { PropostaView } from "./pages/Portal/PropostaView";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/servicos",
        element: <Services />,
      },
      {
        path: "/produtos",
        element: <Products />,
      },
      {
        path: "/pmoc",
        element: <PMOC />,
      },
      {
        path: "/contato",
        element: <Contact />,
      },
      {
        path: "/area-cliente",
        element: <ClientArea />,
      },
      {
        path: "/admin/login",
        element: <AdminLogin />,
      },
      {
        path: "/portal",
        element: <Portal />,
      },
      {
        path: "/portal/pmoc",
        element: <Documents tipo="pmoc" title="PMOC" />,
      },
      {
        path: "/portal/notas-fiscais",
        element: <Documents tipo="nf" title="Notas Fiscais" />,
      },
      {
        path: "/portal/propostas",
        element: <Propostas />,
      },
      {
        path: "/portal/propostas/:id",
        element: <PropostaView />,
      },
    ],
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
]);

export { router };
